export const WINDOW_SIZE = {
    HEIGHT: 650,
    WIDTH: 700,
};
